"use client";

import { useEffect, useState } from "react";
import {
  LandingCasesView,
  type LandingCaseItem,
  type LandingCasesProps,
} from "@/components/landing/cases-view";
import { useLandingCasesPageReportTypes } from "@/components/landing/landing-cases-page-context";

export type { LandingCaseItem, LandingCasesProps };

/** Клиентский блок: library → fetch, manual → props.items. */
export function LandingCases(props: LandingCasesProps) {
  const pageTypesFromContext = useLandingCasesPageReportTypes();
  const pageReportTypes =
    props.pageReportTypes && props.pageReportTypes.length > 0
      ? props.pageReportTypes
      : pageTypesFromContext;
  const source = props.source ?? "manual";
  const limit =
    typeof props.limit === "number" && props.limit > 0 ? props.limit : 6;
  const [libraryItems, setLibraryItems] = useState<LandingCaseItem[] | null>(
    null,
  );

  useEffect(() => {
    if (source !== "library") {
      setLibraryItems(null);
      return;
    }
    let cancelled = false;
    const qs = new URLSearchParams();
    qs.set("limit", String(limit));
    const types =
      props.reportTypes && props.reportTypes.length > 0
        ? props.reportTypes
        : pageReportTypes;
    for (const t of types) qs.append("reportType", t);
    for (const t of props.industries ?? []) qs.append("industry", t);

    void fetch(`/api/public/landing-cases?${qs.toString()}`, {
      cache: "no-store",
    })
      .then((r) => r.json())
      .then((payload: { items?: LandingCaseItem[] }) => {
        if (cancelled) return;
        setLibraryItems(Array.isArray(payload.items) ? payload.items : []);
      })
      .catch(() => {
        if (!cancelled) setLibraryItems([]);
      });

    return () => {
      cancelled = true;
    };
  }, [
    source,
    limit,
    // eslint-disable-next-line react-hooks/exhaustive-deps -- arrays as joined keys
    (props.reportTypes ?? []).join(","),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (props.industries ?? []).join(","),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    pageReportTypes.join(","),
  ]);

  const items =
    source === "library"
      ? (libraryItems ?? [])
      : Array.isArray(props.items)
        ? props.items
        : [];

  return <LandingCasesView {...props} items={items} />;
}
